
import { Component, Prop } from 'vue-property-decorator';
import EventBus from '@/utils/event-bus';
import ObjectWithSignature from '@/utils/interfaces/object-with-signature';
import AppVue from '@/utils/app-vue';
import { AppLanguageHandler } from '@/utils/handlers/app-language-handler';
import { Meta } from '@/utils/decorators';

import Intro from '@/components/intro/intro';

@Component({
    components: {
        Intro,
    },
})
export default class Cineseries extends AppVue {

    @Meta
    private metaInfo() {
        return this.languageMetaInfo;
    }

    @Prop(String) private readonly lang!: string;

    private showPage: boolean = false;

    private get options(): ObjectWithSignature {

        return {
            licenseKey: process.env.VUE_APP_FULLPAGEJS_LICENSE_KEY,
            onLeave: () => {},
            afterLoad: () => {},
            verticalCentered: false,
            scrollOverflow: false,
            scrollOverflowReset: true,
            autoScrolling: true,
            responsiveWidth: 740,
            lockAnchors: true,
        };

    }

    private get languageMetaInfo(): ObjectWithSignature {

        return {

            meta: [
                { name: 'description', content: this.$t('strings.meta.description') },
                { name: 'keyboards', content: this.$t('strings.meta.keyboards') },
            ],

        };

    }

    private created(): void {

        this.$store.commit('dataModule/setBackgroundOnLoading', true);
        // Set background video url
        this.$store.commit('dataModule/setBackgroundUrl', 'page_without_us');

    }

    private mounted(): void {

        AppLanguageHandler.determineLang(this, this.lang);

        EventBus.$on('background-video-loaded', () => {

            this.showPage = true;
            this.$store.commit('dataModule/setBackgroundOnLoading', false);

        });

    }

    private updated(): void {

        this.handleCssStyle();

    }

    private destroyed(): void {

        EventBus.$off([
            'background-video-loaded',
        ]);

    }

}
